import React from 'react'
import PropTypes from 'prop-types'

function More({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 1200"
      className={styling}
    >
      <path d="M222.37 442.05c-85.332 0-154.51 69.121-154.51 154.43 0 85.273 69.18 154.46 154.51 154.46 85.223 0 154.45-69.191 154.45-154.46 0-85.309-69.227-154.43-154.45-154.43zM603.89 442.05c-85.262 0-154.4 69.121-154.4 154.43 0 85.273 69.145 154.46 154.4 154.46 85.297 0 154.46-69.191 154.46-154.46 0-85.309-69.156-154.43-154.46-154.43zM985.49 442.05c-85.234 0-154.45 69.121-154.45 154.43 0 85.273 69.227 154.46 154.45 154.46 85.273 0 154.51-69.191 154.51-154.46 0-85.309-69.238-154.43-154.51-154.43z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
More.propTypes = {
  styling: string,
}

export default More
